import(/* webpackMode: "eager" */ "/app/src/app/(menu)/offers/page.tsx");
